import { createAsyncThunk } from '@reduxjs/toolkit'
import ProfileImage from './profile-image-model'
import {
  delete_profileImage,
  load_profileImages,
  store_profileImage,
} from './profileImage-service'

export const LoadProfileImagesAsync = createAsyncThunk<any, any>(
  'composer/load/profileImage',
  async (params: { uid: string }) => {
    return await load_profileImages(params)
  },
)

export const CreateProfileImageAsync = createAsyncThunk<any, any>(
  'composer/create/profileImage',
  async (params: ProfileImage) => {
    return await store_profileImage(params)
  },
)

export const DeleteProfileImageAsync = createAsyncThunk<any, any>(
  'composer/delete/profileImage',
  async (params) => {
    return await delete_profileImage(params)
  },
)
